import { io, Socket } from 'socket.io-client';
import { chartStore } from '../../stores/ChartStore';
import {balanceStore} from "../../stores/BalanceStore";
import {contractAddresses} from "../../helpers/config/contracts.config";
import {IAccountBalance, IPositionResponse} from "../api/api.interfaces";
import {marketsStore} from "../../stores/MarketsStore";
import {positionsStore} from "../position/position.store";

export interface TickerData {
    s: string; // symbol
    b: string; // bid
    a: string; // ask
    t: number; // timestamp
    o: string; // order book
    it: string; // ignore trade
}

export interface PositionPnL {
    feeAmount: string
    positionId: number
    profit: string
}

class SocketService {
    public socket!: Socket;
    public isConnected = false;
    private currentTickers: string[] = [];
    private currentUserAddress: string | null = null;
    private initialized = false;

    connect() {
        if (this.socket) {
            return;
        }
        //@todo use local API
        // this.socket = io(`ws://localhost:2210`, {
        this.socket = io(process.env.REACT_APP_WEBSOCKET_URL || '', {
            transports: ['websocket']
        });

        this.initialize();

        return this.socket;
    }

    initialize(): Socket {

        if (this.initialized) {
           return this.socket;
        }

        this.initialized = true;

        this.socket.on('connect', () => {
            this.isConnected = true;
            this.resubscribe();
        });

        this.socket.on('ticker', this.handleTicker);

        this.socket.on('position:data', (data: IPositionResponse) => {
            positionsStore.updatePosition(data)
        });
        this.socket.on('position:pnl', (data: PositionPnL) => {

            positionsStore.handlePositionPushPnL(data)
        });
        this.socket.on('account:balance', this.handleAccountBalance)
        this.socket.on('error', (err: Error) => {
            console.log('error', err);
        });

        this.socket.on('disconnect', () => {
            console.log('Disconnected');
            this.socket.connect();
        });

        this.socket.on('close', () => {
            console.log('Closed');
        })

        return this.socket;
    }

    private handleTicker(data: TickerData) {
        if (data) {
            chartStore.updateLatestPrice(data);
            marketsStore.updateLatestPrice(data);
            positionsStore.updateLatestPrice(data);
        }
    }

    private handleAccountBalance(data: IAccountBalance) {
        if (data.token.toLowerCase() ===  contractAddresses.base.usdc.toLowerCase()) {
            balanceStore.setUsdcAvailableBalance(data);
        }
    }

    subscribeToTickers(tickers: string[]) {
        this.currentTickers = tickers;
        this.socket.emit('sub:tickers', { tickers });
    }

    async unsubscribeFromTickers() {
        this.subscribeToTickers([])
    }

    subscribeToUserData(userAddress: string) {
        if (this.currentUserAddress) {
            this.unsubscribeFromPositions();
        }
        this.currentUserAddress = userAddress;
        this.socket.emit('sub:user', { user: userAddress });
    }

    unsubscribeFromPositions() {
        this.socket.emit('unsub:user');
        this.currentUserAddress = null;
    }

    private resubscribe() {
        if (this.currentTickers.length) {
            this.subscribeToTickers(this.currentTickers);
        }
        if (this.currentUserAddress) {
            this.subscribeToUserData(this.currentUserAddress);
        }
    }
}

export const socketService = new SocketService();
